import api from '@/common/api';
import applyStatusHelper from '@/common/applyStatusHelper';
import RouteKey from '@/common/RouteKey';
import MessageType from '@/components/common/message-box/MessageType';
import DescriptionFolder from '@/components/common/DescriptionFolder';
import SubMenu from '../common/SubMenu';
import ErrorHandler from './ErrorHandler';
import { KeyEnum, DisplayMapper } from '@/common/OptionConstant';
import DateUtils from '@/common/DateUtils';
const DateFormat = DateUtils.DateFormat;
const LIST_NUM = 100;

export default {
  name: 'AppDisplayer',
  components: {
    DescriptionFolder,
    SubMenu
  },
  data() {
    return {
      RouteKey,
      applyStatusHelper,
      loaded: false,
      DisplayMapper,
      AppStatusKey: KeyEnum.AppApplyStatus,
      apps: []
    };
  },
  methods: {
    getAllApp() {
      return this.$loader.post(api.ytpublic.GET_ALL_YTPUBLIC, {limit: LIST_NUM}, this.ajaxErrorCallback).then(resData => {
        this.loaded = true;
        resData.items.forEach(app => {
          app.optime = DateUtils.format(new Date(app.optime), DateFormat.DEFAULT);
        });
        this.apps = resData.items;
      });
    },
    handleDeleteApp(softItem) {
      this.$confirm('确认删除后，该应用的AppID、SecretID、SecretKey将失效，相关功能也将失效', '提示', MessageType.INFO).then(() => {
        const loading = this.loading();
        this.confirmDeleteApp(softItem.id)
        .finally(() => {
          loading.close();
        });
      });
    },
    confirmDeleteApp(softId) {
      return this.$loader.post(api.ytpublic.REMOVE_YTPUBLIC, {id: softId}, this.ajaxErrorCallback).then(() => {
        this.getAllApp();
        this.$alert('删除应用成功', null, MessageType.SUCCESS);
      });
    },
    // 判断申请数量
    openCreatePublic() {
      if (this.apps.length >= LIST_NUM) {
        this.$alert('可申请公有云服务上限为100，如需继续申请，请删除列表中的部分授权', '申请数量超限', MessageType.FAIL);
      } else {
        this.$router.transfer(RouteKey.OPEN_APP_CREATOR, {id: this.apps[0].id});
      }
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
    this.getAllApp();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/AppDisplayer.js